import { defineMessages } from 'react-intl';

export function schema({ formData, intl }) {
  return {
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['styles'],
      },
    ],
    properties: {
      styles: {
        title: intl.formatMessage(messages.styles),
        description: intl.formatMessage(messages.styles_desc),
      },
    },
    required: [],
  };
}

const messages = defineMessages({
  script: {
    id: 'script_embed_script_title',
    defaultMessage: 'Script URL',
  },
  script_desc: {
    id: 'script_embed_script_description',
    defaultMessage: 'Insert the URL of the script to embed',
  },
  styles: {
    id: 'script_embed_styles_title',
    defaultMessage: 'Styles URL',
  },
  styles_desc: {
    id: 'script_embed_styles_description',
    defaultMessage: 'Insert the URL of the stylesheet to embed',
  },
});
